import type React from 'react';
import { toast } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { UndoneMessage } from '../../importUndo';

/** A kept line gives the reader more to take in: 10 s instead of the default 4 s. */
export const UNDONE_TOAST_KEPT_TIMEOUT = 10_000;

type UndoneToastDescriptionProps = Pick<UndoneMessage, 'summary' | 'kept'>;

/**
 * The toast's body: what went, then, on a line of its own, what stayed and
 * why. Spans, since the toast's description may be a paragraph.
 */
export const UndoneToastDescription: React.FC<UndoneToastDescriptionProps> = ({
    summary,
    kept,
}) => (
    <>
        <span className="block">{summary}</span>
        {kept === null ? null : (
            <span
                className="mt-1 block"
                {...getNodeTestIdProp('catalog-import-result-undone-kept')}
            >
                {kept}
            </span>
        )}
    </>
);

/**
 * Says the import was undone, in a success toast that outlives the step:
 * the wizard is on Branch by the time it is read.
 */
export const showUndoneToast = ({ title, summary, kept }: UndoneMessage) => {
    toast.success(title, {
        description: <UndoneToastDescription kept={kept} summary={summary} />,
        ...(kept === null ? {} : { timeout: UNDONE_TOAST_KEPT_TIMEOUT }),
    });
};
